module.exports = __webpack_public_path__ + "static/media/image7.3622fb70.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/carAuthorization/img/image7.png
// module id = 330
// module chunks = 0